<mat-card class="example-card">
  <mat-card-header>
    <mat-card-title>Journal</mat-card-title>
    <mat-card-subtitle>Options</mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>
    <form [formGroup]="filterFormGroup" (submit)="getJournal()">
      <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px" fxLayoutGap.lt-md="0px" fx-layout-align="end">
        <mat-form-field>
          <mat-label>Up to date</mat-label>
          <mat-date-range-input [rangePicker]="picker">
            <input matStartDate placeholder="Start date" formControlName="date_from">
            <input matEndDate placeholder="End date" formControlName="date_to">
          </mat-date-range-input>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>



      </div>

      <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px" fxLayoutGap.lt-md="0px" fx-layout-align="end">
        <button mat-raised-button color="primary" type="submit">Generate Report</button>
      </div>
    </form>
  </mat-card-content>
</mat-card>

<mat-card class="example-card" *ngIf="loaded">
  <div style="text-align: center;">Venkor Inc</div>
  <div style="text-align: center;">JOURNAL</div>
  <div style="text-align: center;">{{data.date_from | date:'MMM d, y'}} - {{data.date_to | date:'MMM d, y'}}</div>


  <table>
    <tr>
      <th>DATE</th><th>TRANSACTION TYPE</th><th>#</th><th>NAME</th><th>MEMO/DESCRIPTION</th><th>ACCOUNT</th><th>DEBIT</th><th>CREDIT</th>
    </tr>
    <ng-container *ngFor="let voucher of data.vouchers">
        <ng-container *ngFor="let entry of voucher.entries; let first = first;">
          <tr>
          <ng-container *ngIf="first; else elseNotFirst">
              <td style="white-space: nowrap;">{{voucher.date}}</td>
              <td>{{voucher.type_name}}</td>
              <td>{{voucher.number}}</td>
              <td></td>
              <td>{{voucher.description}}</td>
              <td>{{entry.account_name}}</td>
              <td>{{entry.debit | number}}</td>
              <td>{{entry.credit | number}}</td>

          </ng-container>
          <ng-template #elseNotFirst>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td>{{entry.account_name}}</td>
            <td>{{entry.debit | number}}</td>
            <td>{{entry.credit | number}}</td>

          </ng-template>
        </tr>

        </ng-container>
        <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td><strong>{{totalDebit(voucher) | number}}</strong></td>
            <td><strong>{{totalCredit(voucher) | number}}</strong></td>
        </tr>
    </ng-container>

  </table>

  </mat-card>
